/**
 * Loại tổng hợp khi chọn tham số báo cáo
 * nxhinh 15.08.2024
 */
export default {
    // Tổng hợp
    Summary: 1, 
    // Tất cả
    All: 2,
    // Chi tiết đơn vị
    Detail: 3,
  };
  